export default __webpack_public_path__ + "assets/img/goto-training-lockup.7a9ec3de331b0b36a81ec9e7c62acd04.svg";